import React from "react";
import { motion } from "framer-motion";
import ResumeCard from "./ResumeCard";

const Experience = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="py-12 font-titleFont flex gap-20"
    >
      {/* Professional Experience */}
      <div>
        <div className="flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">2024 - PRESENT</p>
          <h2 className="text-4xl font-bold">Job Experience</h2>
        </div>
        <div className="mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="Backend & Platform Engineer"
            subTitle="Fresh Finest — US-based E-commerce (Jul 2024 – Present)"
            result="Onsite"
            des="Sole backend engineer for a multi-platform US e-commerce operation. Architected, built, and deployed four production systems — dynamic repricing engine, warehouse management system, multi-platform marketplace connectors, and full CI/CD infrastructure."
          />
          <ResumeCard
            title="Key Achievement — Repricing Engine"
            subTitle="Automated Pricing System"
            result="PRODUCTION"
            des="Shipped a rule-based dynamic repricing engine with competitor price monitoring and bulk price adjustment for large product catalogs — handles pricing at scale with zero manual intervention."
          />
          <ResumeCard
            title="Key Achievement — Marketplace Integrations"
            subTitle="Amazon • Walmart • TikTok Shop • Etsy"
            result="PRODUCTION"
            des="Designed and integrated multi-platform marketplace connectors including OAuth2 token lifecycle management and rate-limit handling across Amazon SP-API, Amazon Ads, Walmart, TikTok Shop, Temu, and Etsy."
          />
        </div>
      </div>

      {/* DevOps & Infrastructure Projects */}
      <div>
        <div className="flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">2023 - PRESENT</p>
          <h2 className="text-4xl font-bold">DevOps & Infrastructure</h2>
        </div>
        <div className="mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="DevSecOps CI/CD Pipeline"
            subTitle="Jenkins • Docker • Kubernetes • Prometheus • Grafana"
            result="OPEN SOURCE"
            des="Designed a complete CI/CD pipeline for 4 microservices with automated build, Trivy + OWASP + SonarQube security gates, and Kubernetes deployment with real-time Prometheus/Grafana monitoring dashboards."
          />
          <ResumeCard
            title="Blue-Green Zero-Downtime Deployment"
            subTitle="AWS EC2 • Docker • GitHub Actions • NGINX"
            result="PRODUCTION"
            des="Implemented zero-downtime Blue-Green strategy using Docker containers and NGINX traffic switching. Automated full pipeline — push to main triggers live deployment in under 5 minutes."
          />
          <ResumeCard
            title="Kubernetes Cluster Deployments"
            subTitle="AWS EKS • kubeadm • Helm • Minikube"
            result="OPEN SOURCE"
            des="Provisioned multi-node Kubernetes clusters on AWS EC2 using kubeadm. Deployed microservices using Kubernetes manifests, Helm charts, and Ingress controllers. Explored AWS EKS for managed Kubernetes at scale."
          />
        </div>
      </div>
    </motion.div>
  );
};

export default Experience;